<template>
  <div class="edit-authority-scheme">
    <div class="main-title">
      <p>权限管理</p>
    </div>
    <div class="main-body">
      <div class="row">
        <div class="label">方案编号：</div>
        <el-input class="fixed-width" size="mini" v-model="schemeNo" disabled></el-input>
      </div>
      <div class="row">
        <div class="label">方案名称：</div>
        <el-input class="fixed-width" size="mini" v-model="schemeName" clearable></el-input>
      </div>
      <div class="row">
        <div class="label">权限功能：</div>
        <div class="row-right width-960">
          <div class="row" v-for="(value,key) in allAuthority">
            <div class="label">{{ key }}</div>
            <div class="row-right width-850">
              <el-checkbox-group v-model="authorityList">
                <el-checkbox v-for="(name,code) in value" :label="code" :key="code">{{ name }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row fixed-padding">
        <div class="normal-btn" @click="onCancelBtnClick">取消</div>
        <div class="blue-btn" @click="onConfirmBtnClick">确认</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'authoritySchemeMgmtEditView',
  data() {
    return {
      schemeNo: '',
      schemeName: '',
      authorityList: [],
      allAuthority: {}
    }
  },
  mounted() {
    this.schemeNo = this.$route.query.schemeNo;
    this.schemeName = this.$route.query.schemeName;
    this.queryAllAuthority();
    this.queryAuthoritySchemeDetail();
  },
  methods: {
    queryAuthoritySchemeDetail() {
      let self = this;
      let params = {
        schemeNo: this.schemeNo
      };
      this.$http.post('/managementPlatform/authority/queryAuthoritySchemeDetail', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.authorityList = res.mdata.chosenAuthority;
      }).catch(function (response) {
        console.log(response);
      });
    },
    queryAllAuthority() {
      let self = this;
      this.$http.post('/managementPlatform/authority/queryAllAuthority').then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.allAuthority = res.mdata.authorityList;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onConfirmBtnClick() {
      this.addOrUpdateScheme();
    },
    onCancelBtnClick() {
      this.$router.back();
    },
    addOrUpdateScheme() {
      let self = this;
      let params = {
        schemeNo: this.schemeNo,
        schemeName: this.schemeName,
        authorityList: JSON.stringify(this.authorityList),
      };
      this.$http.post('/managementPlatform/authority/addOrUpdateScheme', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "编辑成功！",
          center: true
        });
        self.onCancelBtnClick();
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0;

  .row-right {
    display: inline-block;
  }

  .fixed-width {
    width: 165px;
  }

  .width-850 {
    width: 850px;
  }

  .width-960 {
    width: 960px;

    .row {
      margin-top: 0;
    }

    .label {
      margin-left: 0;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: right;
    min-width: 50px;
    margin: 0 14px;
    line-height: 25px;
  }

  .normal-btn, .blue-btn {
    margin-left: 14px;
  }
}

.fixed-padding {
  padding-left: 14px;
}
</style>
<style>
.el-checkbox__label {
  width: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/unitMgmt/authoritySchemeMgmtEditView.vue